/**
 * Polyfill for ReactDOM.findDOMNode which was removed in React 19
 * This is needed for react-quill which hasn't been updated for React 19 yet
 */
import ReactDOM from 'react-dom';

if (!(ReactDOM as any).findDOMNode) {
	(ReactDOM as any).findDOMNode = (component: any) => {
		if (component === null) {
			return null;
		}

		// If it's already a DOM node, return it
		if (component.nodeType === 1) {
			return component;
		}

		// Try to get DOM node from React internals (React 19)
		try {
			// For function components or newer React versions
			if (component._reactInternals) {
				let fiber = component._reactInternals;
				while (fiber) {
					if (fiber.stateNode?.nodeType === 1) {
						return fiber.stateNode;
					}

					fiber = fiber.child;
				}
			}

			// Fallback: if component has a ref
			if (component.ref?.current) {
				return component.ref.current;
			}
		} catch (e) {
			console.warn('findDOMNode polyfill failed:', e);
		}

		return null;
	};
}

export {};
